import React from 'react';

const RadioButtons = ({ label, options, selectedOption, setOption }) => (
  <div className={`form-item radio ${label.replace(/ /g, '-').toLowerCase()}`}>
    <label className="label">{label}</label>
    <div className="radio-items">
      {options.map(({ label, value, text }, idx) => (
        <div key={idx} className="radio-option">
          <div className="label-area">
            <span
              className={`radio-btn ${value === selectedOption ? 'selected' : ''}`}
              onClick={() => setOption(value)}
            >
              <span className="fill"></span>
            </span>
            <span>{label}</span>
          </div>
          <p className="radio-text">{text}</p>
        </div>
      ))}
    </div>
  </div>
);

export default RadioButtons;
